<template>
  <el-row class="warp">
    <img src="../assets/images/index.jpg" style="width:100%"/>
    <el-row :gutter="20" style="line-height: 100px;">
      <el-col :span="6">
        <a href="http://yjglt.henan.gov.cn/">河南省应急管理厅</a>
      </el-col>
      <el-col :span="6">
        <a href="http://yjglj.sh.gov.cn/">上海应急管理</a>
      </el-col>
      <el-col :span="6">
        <a href="https://www.mem.gov.cn/">中华人民共和国应急管理部</a>
      </el-col>
      <el-col :span="6">
        <a href="http://ha.119.gov.cn/">河南消防</a>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import util from '../common/util';
import API from '../api/api_dashboard';
export default {
  data(){
     return {
       
      }
  },
  methods:{
    
  },
  mounted() {

  },
  components: {
    
  }

}
</script>


// WEBPACK FOOTER //
// Dashboard.vue?348c06e7